import { motion } from "framer-motion";
import { Check, ChevronRight, Lock } from "lucide-react";
import { stageProgress, LEVEL_LABEL } from "../../engine";
import { useGame } from "../../state/GameProvider";

/**
 * 學程 — the twenty chapters as a route, grouped into five stages.
 *
 * Nothing is hard-locked: a stage the student has not reached yet is marked
 * as "not yet recommended" but still opens. Blocking access to 顏淵 because
 * 里仁 is unfinished would serve the game, not the reading.
 */
export function PathView() {
  const { state, actions } = useGame();
  const stages = stageProgress(state.progress);

  return (
    <div className="view path">
      <header className="view-head">
        <h2>學程</h2>
        <p>二十篇分五段，順序是建議，不是門禁。</p>
      </header>

      {stages.map((entry, index) => (
        <motion.section
          key={entry.stage.id}
          className={`stage${entry.recommended ? "" : " ahead"}`}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: index * 0.05 }}
        >
          <div className="stage-head">
            <span className="stage-no">{index + 1}</span>
            <div>
              <strong>{entry.stage.label}</strong>
              <small>{entry.stage.aim}</small>
            </div>
            <span className="stage-pct">{entry.percent}%</span>
          </div>
          <div className="stage-bar">
            <motion.i
              initial={{ width: 0 }}
              animate={{ width: `${entry.percent}%` }}
              transition={{ duration: 0.7, ease: "easeOut" }}
            />
          </div>

          <div className="chapter-grid">
            {entry.chapters.map((chapter) => (
              <button
                key={chapter.major}
                className={`chapter-cell lv${chapter.level}`}
                onClick={() => actions.start({ chapter: chapter.major, mode: "auto" })}
                title={`${chapter.name}：${chapter.mastered}/${chapter.total} 章已通`}
              >
                <span className="ch-name">{chapter.name}</span>
                <span className="ch-meta">
                  {chapter.mastered}/{chapter.total}
                </span>
                <span className="ch-level">
                  {chapter.percent === 100 ? <Check size={12} /> : LEVEL_LABEL[chapter.level]}
                </span>
                <i className="ch-fill" style={{ width: `${chapter.percent}%` }} />
              </button>
            ))}
          </div>

          {!entry.recommended && (
            <div className="stage-note">
              <Lock size={12} /> 前一段還不到略通，此段可讀但會較吃力
            </div>
          )}
        </motion.section>
      ))}

      <button className="path-cta" onClick={() => actions.start({ chapter: "all", mode: "auto" })}>
        由系統挑下一則 <ChevronRight size={16} />
      </button>
    </div>
  );
}
